import { render } from "./sub_category_attributes.vue?vue&type=template&id=0685c0c8"
import script from "./sub_category_attributes.vue?vue&type=script&lang=js"
export * from "./sub_category_attributes.vue?vue&type=script&lang=js"

import "./sub_category_attributes.vue?vue&type=style&index=0&id=0685c0c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__